import { UpdatableConfig } from './types/config'

/** The AlgoKit config. To update it use the configure method. */
export const Config = new UpdatableConfig()
